import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    Image,
    Title,
    Row,
} from 'yurstrap';

import { closeModal } from '../../reduxModules/App';

import illuMailSent from '../../../../../images/support/illu__mail--sent.svg';

const propTypes = {
    AppActions: PropTypes.shape({
        closeModal: PropTypes.func.isRequired,
    }).isRequired,
};

const defaultProps = {};

class ContactSupportEmailSuccess extends Component {

    constructor(props) {
        super(props);
        this.onCloseModal = this.onCloseModal.bind(this);
    }

    onCloseModal() {
        const { AppActions } = this.props;
        AppActions.closeModal();
    }

    render() {
        return (
            <Row vcenter hcenter className="u-bg__white">
                <div className="u-col--m-8 u-col--s-12 py--m-5 u-text-align--center">
                    <Image
                        alt="Mail has been sent illustration"
                        size="m"
                        className="mb-3 mx-a"
                        src={illuMailSent}
                    />
                    <Title className="u-color__green--30">
                        Message envoyé !
                    </Title>
                    <p className="u-font-size--3 u-color__grey--60">
                        Votre demande a bien été prise en compte !
                        <br />
                        Notre équipe support y répondra sous 24h ouvrées.
                    </p>
                </div>
            </Row>
        );
    }

}

ContactSupportEmailSuccess.propTypes = propTypes;

ContactSupportEmailSuccess.defaultProps = defaultProps;

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            closeModal,
        }, dispatch),
    };
}

export default connect(undefined, mapDispatchToProps)(ContactSupportEmailSuccess);
